import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { ToastContainer, toast } from 'react-toastify';
import { setAddressDetails } from '../../redux/reducers/cartSlice';
import 'react-toastify/dist/ReactToastify.css';
import styles from '../../styles/shipping.module.css';

function Shipping() {
  const [postalCode, setPostalCode] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [address, setAddress] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state);

  useEffect(() => {
    if (cart.length === 0) {
      navigate('/cart');
    }
  }, [cart, navigate]);

  const validate = () => {
    if (!postalCode || !postalCode.trim()) {
      toast.error('Please provide postal code', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    if (!address || !address.trim()) {
      toast.error('Please provide address', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    if (!country || !country.trim()) {
      toast.error('Please provide country', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    if (!mobileNumber || mobileNumber.length < 10) {
      toast.error('Please provide a valid 10-digit phone number', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    if (!city || !city.trim()) {
      toast.error('Please provide city', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validate();

    if (isValid) {
      dispatch(setAddressDetails({
        postalCode: postalCode.trim(),
        country: country.trim(),
        city: city.trim(),
        mobileNumber: mobileNumber.trim(),
        address: address.trim()
      }));
      navigate('/placeorder');
    }
  };

  return (
    <div className={styles.shippingContainer}>
      <Navbar />
      
      <div className={styles.shippingContent}>
        <div className={styles.shippingCard}>
          <div className={styles.headerSection}>
            <h3 className={styles.pageTitle}>Shipping Details</h3>
            <p className={styles.pageSubtitle}>Enter your shipping information</p>
          </div>

          <form className={styles.shippingForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="address" className={styles.formLabel}>
                Address <span className={styles.required}>*</span>
              </label>
              <input
                id="address"
                className={styles.formInput}
                value={address}
                autoComplete="off"
                onChange={(e) => setAddress(e.target.value)}
                type="text"
                placeholder="Enter your street address"
              />
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="city" className={styles.formLabel}>
                  City <span className={styles.required}>*</span>
                </label>
                <input
                  id="city"
                  className={styles.formInput}
                  value={city}
                  autoComplete="off"
                  onChange={(e) => setCity(e.target.value)}
                  type="text"
                  placeholder="Enter city"
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="postalCode" className={styles.formLabel}>
                  Postal Code <span className={styles.required}>*</span>
                </label>
                <input
                  id="postalCode"
                  className={styles.formInput}
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  type="text"
                  autoComplete="off"
                  placeholder="Enter postal code"
                />
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="country" className={styles.formLabel}>
                  Country <span className={styles.required}>*</span>
                </label>
                <input
                  id="country"
                  className={styles.formInput}
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  type="text"
                  autoComplete="off"
                  placeholder="Enter country"
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="mobileNumber" className={styles.formLabel}>
                  Phone Number <span className={styles.required}>*</span>
                </label>
                <input
                  id="mobileNumber"
                  className={styles.formInput}
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  type="tel"
                  autoComplete="off"
                  placeholder="Enter 10-digit phone number"
                  maxLength="10"
                />
              </div>
            </div>

            <button type="submit" className={styles.submitBtn}>
              Continue to Payment
            </button>
          </form>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Shipping;